import { Injectable } from '@angular/core';
import { RouteConstants } from '../../../../../core/constants/routes';
import { StepLink } from '../../models/step-link';

@Injectable({
    providedIn: 'root',
})
export class ApplicationEventActionButtonVisibilityService {
    /**
     * If the current step needs the delete button displayed.
     * @param stepLink Current step link.
     * @returns Boolean value indicating if the delete button should be displayed.
     */
    needsDeleteButton(stepLink: StepLink, handoverToEwa: boolean): boolean {
        const onAllowedRoute =
            RouteConstants.Application.isDirectEntryRoute(stepLink.url) ||
            RouteConstants.Application.isUnsupportedApplicationRoute(
                stepLink.url,
            );

        return onAllowedRoute && !handoverToEwa;
    }

    /**
     * If the application needs the modify template button displayed.
     * @returns Boolean value indicating if the modify template button should be displayed.
     */
    needsModifyTemplateButton(isApplicationTemplate: boolean): boolean {
        return isApplicationTemplate;
    }

    /**
     * If the current step needs the create template button displayed.
     * @param stepLink Current step link.
     * @param isPurposePermitted Boolean value indicating if the purpose is permitted.
     * @param isApplicationTemplate Boolean value indicating if the application is a template.
     * @returns Boolean value indicating if the create template button should be displayed.
     */
    needsCreateTemplateButton(
        stepLink: StepLink,
        isPurposePermitted: boolean,
        isApplicationTemplate: boolean,
    ): boolean {
        return (
            RouteConstants.Application.isDirectEntryRoute(stepLink.url) &&
            !isApplicationTemplate &&
            isPurposePermitted
        );
    }
}
